module.exports = __webpack_public_path__ + "img/p2-6.5c2ce04e.png";